import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';

const liffId = config.liff_id.changeContact;

const PolicyListContact = loadable(() => import('./PolicyListContact'), { fallback: null });

const ConfirmationDetail = loadable(() => import('./ConfirmationDetail'), { fallback: null });

const RejectScreen = loadable(() => import('./RejectScreen'), { fallback: null });

const ChangeContactForm = loadable(() => import('./ChangeContactForm'), { fallback: null });

const ChangeContactOtp = loadable(() => import('./ChangeContactOtp'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

const NotFoundChangeContact = loadable(() => import('./NotFoundChangeContact'), { fallback: null });

export default function ChangeContactRoute() {
    return (
        <Routes>
            <Route path="/" element={
                <AuthProvider liffId={liffId}>
                    <CheckCMSNewVersionLayer>
                        <PolicyListContact />
                    </CheckCMSNewVersionLayer>
                </AuthProvider>
            } />
            <Route path="notfound-change-contact" element={<NotFoundChangeContact />} />
            <Route path="reject-screen" element={<RejectScreen />} />
            <Route path="confirmation-detail" element={<ConfirmationDetail />} />
            <Route path="change-contact-form" element={<ChangeContactForm />} />
            <Route path="confirmation-otp" element={<ChangeContactOtp />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
